var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLink)?_c('a',{class:_vm.linkClass,attrs:{"href":_vm.url}},[_vm._v("\n    "+_vm._s(_vm.displayText)),(_vm.isStoryFooterCta)?_c('span',[_vm._v(" →")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isButton)?_c('a',{staticClass:"link link--button",attrs:{"href":_vm.url}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e09f9a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generics/link/link.vue
// module id = svCT
// module chunks = 0